import axiosInstance, { microServices } from 'network/apis/index'
// import { SuccessMessage } from 'network/messageTranslationHelpers/messages'
import { getAuthToken } from 'utils/common-services/cookie.service'
import { METHOD_TYPES } from 'utils/constants/index'

const getAuthHeaders = () => {
  const token = getAuthToken()
  return token ? { authorization: `Bearer ${token}` } : {}
}

export const CRASH_STATUS_REQUEST_TIMEOUT_MS = 8000

export const placeBetCrashGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'crash-game/place-bet-crash-game', data, {
    server: microServices.USER_URL
    // successMessage: SuccessMessage.betPlacedSuccessfully
  })
}
export const escapeCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'crash-game/player-escape-crash-game', data, {
    server: microServices.USER_URL
  })
}

export const cancelCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'crash-game/cancel-bet-crash-game', data, {
    server: microServices.USER_URL
    // successMessage: SuccessMessage.betCancelledSuccessfully
  })
}
export const getAllRoundHistoryService = () => {
  return axiosInstance(METHOD_TYPES.get, '/crash-game/get-crash-game-history', {}, {
    headers: getAuthHeaders(),
    server: microServices.USER_URL
  })
}

export const getCrashGameStatusService = ({ signal } = {}) => {
  return axiosInstance(METHOD_TYPES.get, '/crash-game/get-crash-game-status', {}, {
    headers: getAuthHeaders(),
    server: microServices.USER_URL,
    suppressErrorToast: true,
    timeout: CRASH_STATUS_REQUEST_TIMEOUT_MS,
    signal
  })
}

export const getCrashGameUnfinishedBetService = () => {
  return axiosInstance(METHOD_TYPES.get, '/crash-game/unfinished-bet', {}, {
    headers: getAuthHeaders(),
    server: microServices.USER_URL,
    suppressErrorToast: true
  })
}

export const getMyBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/crash-game/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getFreeBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/system/free-bet-details', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getMyStatsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/crash-game/my-stats', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getPreviousRoundBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'crash-game/previous-round-placed-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getTopBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/crash-game/top-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const verifyProvableFairCrashService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'crash-game/check-provable-fair', data, {
    server: microServices.USER_URL
  })
}
